import { RequestService } from '@/api/services/request.service';
import { buildRequestData } from '@/components/TariffCalculatorNew/components/calculator/Calculator.utils';

type SendCalculatorFormDataRequest = ReturnType<typeof buildRequestData>;

export const sendCalculatorFormData = async (payload: SendCalculatorFormDataRequest) => {
	const request = RequestService.getInstance();

	try {
		const { data } = await request.post<SendCalculatorFormDataRequest>(
			'api/v2/amo-crm/calculator/',
			payload,
		);

		return data;
	} catch (error) {
		throw error.response?.data ?? error.message ?? error.statusText;
	}
};
